import BoxGrid from '@/main/components/shared/boxGrid/boxGrid';
import { PartCatalogRequest } from '@/main/models/request';
import React, { useState } from 'react';
import { IGridData, IModalDetails } from '../../partsCatalogScreen';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';
import ResultNotFoundComponent from '@/main/components/shared/resultNotFound/resultNotFoundComponent';
import { getDefaultMessageResultsFound, getTranslateByKey } from '@/main/services/utils';
import { PaginationEnum } from '@/main/services/enum/PaginationEnum';
import { partCatalogApi } from '@/main/api';
import { KOGTableRow } from '@/main/components/shared/boxGrid/styles';
import { TableCell, Tooltip } from '@mui/material';

import * as S from './styles';
import { PartCatalogResponse } from '@/main/models/response/partCatalogResponse';

interface IPartsCatalogGrid {
  formFilters: PartCatalogRequest | null;
  gridData: IGridData;
  hasShowMore: boolean;
  setHasShowMore: React.Dispatch<React.SetStateAction<boolean>>;
  setGridData: React.Dispatch<React.SetStateAction<IGridData>>;
  setModalDetails: React.Dispatch<React.SetStateAction<IModalDetails>>;
  pageIndex: PaginationEnum;
  setPageIndex: React.Dispatch<React.SetStateAction<PaginationEnum>>
  isLoadingInfiniteScroll: boolean;
  setIsLoadingInfiniteScroll: React.Dispatch<React.SetStateAction<boolean>>;
}
function PartsCatalogGrid({
  formFilters,
  hasShowMore,
  gridData,
  setHasShowMore,
  setGridData,
  setModalDetails,
  pageIndex,
  setPageIndex,
  isLoadingInfiniteScroll,
  setIsLoadingInfiniteScroll
}: IPartsCatalogGrid) {


  // ASYNC FUNCTIONS
  function onLoadInfiniteScroll(request: PartCatalogRequest) {
    setIsLoadingInfiniteScroll(true);

    partCatalogApi
      .searchgrid(request)
      .then(response => {
        let resultData: PartCatalogResponse[] = [];
        let resultTotalItems: number = 0;
        if (
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          resultData = response.data.results;
          resultTotalItems = response.data.totalNumberOfRecords;
        }
        if (gridData.data.length > 0) {
          resultData = [...gridData.data, ...resultData];
        }
        setGridData({
          isLoading: false,
          totalItems: resultTotalItems,
          data: resultData
        });

        // Disable show more
        if (
          resultTotalItems < PaginationEnum.PageSize10 ||
          resultTotalItems === resultData.length
        ) {
          setHasShowMore(false);
        }
      })
      .finally(() => setIsLoadingInfiniteScroll(false));
  }

  function onLoadSearchGrid() {
    const index = pageIndex + PaginationEnum.PageIndexIntial;
    setPageIndex(index);
    const formFiltersOnLoadSearchGrid = formFilters;
    if (formFiltersOnLoadSearchGrid) {
      const updatedFormFilters = {
        ...formFiltersOnLoadSearchGrid,
        pageIndex: index
      };
      onLoadInfiniteScroll(updatedFormFilters);
    }
  }


  if (gridData.isLoading) return <LoadingComponent />;
  if (gridData.data.length === 0 && formFilters !== null)
    return <ResultNotFoundComponent styles={{ marginTop: 10 }} />;
  if (gridData.data.length === 0 && !gridData.isLoading) return null;

  // CONSTANTS LAYOUT
  const titleGrid = getDefaultMessageResultsFound(
    gridData.data.length,
    gridData.totalItems
  );
  const rowHeaders = [
    getTranslateByKey('information.partnumber'),
    getTranslateByKey('information.description'),
    getTranslateByKey('information.part'),
    getTranslateByKey('information.position'),
    getTranslateByKey('information.vehicles')
  ];
  return (
    <BoxGrid
      title={titleGrid}
      rowHeaders={rowHeaders}
      infiniteScrollConfig={{
        dataLength: gridData.data.length,
        fetchData: () => onLoadSearchGrid(),
        hasMore: hasShowMore,
        isLoading: isLoadingInfiniteScroll,
      }}>
      {gridData.data.map(part => (
        <KOGTableRow
          key={part.guidPartCatalog}
          onClick={() => setModalDetails({ opanModal: true, guid: part.guidPartCatalog })}
          id={`id-partsCatalog-tableRow-result-${part.partNumber}`}>
          <TableCell width="15%">{part.partNumber}</TableCell>
          <TableCell width="20%">{part.description}</TableCell>
          <TableCell width="20%">{part.partName}</TableCell>
          <TableCell width="15%">{part.position}</TableCell>
          <TableCell width="30%">
            <S.ListVehiclesGrid title={part.vehicles.map(vehicle => `${vehicle}`).join(', ')}>
              {part.vehicles.length > 1 ? `${part.vehicles[0]}...` : part.vehicles[0]}
            </S.ListVehiclesGrid>
          </TableCell>
        </KOGTableRow>
      ))}
    </BoxGrid>
  )

}

export default PartsCatalogGrid;